module.exports = __webpack_public_path__ + "473e84fc7eda43720b6667752976b5a8.MP3";